import {
  Box,
  Divider,
  Flex,
  HStack,
  Icon,
  Stack,
  VStack,
} from '@chakra-ui/react';
import { BankIcon, RadioButtonGroup, Text } from '@diamond/shared/ui';
import { useGetBankAccount } from '@diamond/sol-buyer-context';
import { CreditCard } from '@mui/icons-material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

interface paymentMethodProps {
  payment_method?: string;
  onPaymentChange?: (paymentType: string) => void;
}
export function PaymentMethod({
  payment_method,
  onPaymentChange,
}: paymentMethodProps) {
  const { data: bankAccountData } = useGetBankAccount();
  const form = useFormContext();

  const noRek = bankAccountData?.bank_account_number;
  const bankAccountHolder = bankAccountData?.bank_account_holder;
  const bank = bankAccountData?.bank_name;

  const handlePaymentChange = (value: string) => {
    if (onPaymentChange) {
      onPaymentChange(value);
    }
  };

  useEffect(() => {
    if (payment_method === 'term_of_payment') {
      form.setValue('payment_method', 'term_of_payment');
      // Track payment info for TOP
      if (onPaymentChange) {
        onPaymentChange('term_of_payment');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options =
    payment_method === 'term_of_payment'
      ? [
          {
            label: 'TOP',
            value: 'term_of_payment',
            children: (
              <HStack>
                <Box justifyContent="center" alignItems="center" mx="2">
                  <Flex>
                    <Text fontSize="2xl" fontWeight="bold">
                      TOP
                    </Text>
                    <Box
                      px="2"
                      border="1px"
                      ml={4}
                      pt="2px"
                      rounded="lg"
                      borderColor="#7928CA"
                      w={{ base: '-moz-fit-content', md: 'auto' }}
                      alignSelf="normal"
                    >
                      <Text
                        as="i"
                        fontWeight="bold"
                        bgGradient="linear(to-l, #7928CA, #FF0080)"
                        bgClip="text"
                        fontSize={{ base: '8px', md: '10px' }}
                      >
                        TERM OF PAYMENT
                      </Text>
                    </Box>
                  </Flex>
                  <Text
                    fontSize={{ base: '12px', md: '14px' }}
                    fontWeight="medium"
                    as="span"
                  >
                    (Term of payment)
                  </Text>
                </Box>
              </HStack>
            ),
          },
        ]
      : [
          {
            label: 'COD',
            value: 'cash_on_delivery',
            children: (
              <Stack w="full">
                <VStack alignItems="baseline">
                  <HStack>
                    <Box justifyContent="center" alignItems="center" mx="2">
                      <Flex>
                        <Text fontSize="2xl" fontWeight="bold">
                          COD
                        </Text>
                        <Box
                          px="2"
                          border="1px"
                          ml={4}
                          pt="2px"
                          rounded="lg"
                          borderColor="#7928CA"
                          w={{ base: '-moz-fit-content', md: 'auto' }}
                          alignSelf="normal"
                        >
                          <Text
                            as="i"
                            fontWeight="bold"
                            bgGradient="linear(to-l, #7928CA, #FF0080)"
                            bgClip="text"
                            fontSize={{ base: '8px', md: '10px' }}
                          >
                            CASH ON DELIVERY
                          </Text>
                        </Box>
                      </Flex>
                      <Text
                        fontSize={{ base: '12px', md: '14px' }}
                        fontWeight="medium"
                        as="span"
                      >
                        Pembayaran saat penerimaan barang
                      </Text>
                    </Box>
                  </HStack>
                </VStack>
              </Stack>
            ),
          },
          {
            label: `${bank}`,
            value: 'bank_transfer',
            children: (
              <VStack alignItems="baseline" mx="2">
                <HStack>
                  <Box w="full">
                    <Flex gap="4">
                      <Text
                        fontSize={{ base: 'lg', md: '2xl' }}
                        fontWeight="bold"
                      >
                        Bayar Sekarang
                      </Text>
                      {bank && <BankIcon bank={bank} />}
                    </Flex>
                    <Box>
                      <Text
                        fontSize={{ base: '12px', md: '14px' }}
                        fontWeight="semibold"
                        as="span"
                        color="gray.75"
                      >
                        No. Rekening:
                      </Text>
                      <Text
                        fontSize={{ base: '12px', md: '14px' }}
                        fontWeight="semibold"
                        as="span"
                      >
                        {noRek}
                      </Text>
                      <Text fontSize="sm" fontWeight="semibold">
                        {`a/n ${bankAccountHolder}`}
                      </Text>
                      <Text fontSize="sm" fontWeight="medium" color="#E28800">
                        Segera Unggah bukti transfer setelah PO berhasil dibuat
                        agar pesanan diproses
                      </Text>
                    </Box>
                  </Box>
                </HStack>
              </VStack>
            ),
          },
        ];

  return (
    <Box
      flex="1"
      border="1px"
      borderColor="gray.33"
      shadow="base"
      px="4"
      py="6"
      rounded="lg"
    >
      <Flex>
        <Flex justifyContent="center" alignItems="center" mr="2">
          <Icon as={CreditCard} color="blue" boxSize={8} />
        </Flex>
        <Box>
          <Text fontSize="20px" fontWeight="bold">
            Metode Pembayaran
          </Text>
        </Box>
      </Flex>
      <Divider borderWidth="1px" my="4" />

      {payment_method !== undefined ? (
        payment_method === 'term_of_payment' ? (
          <Box>{options[0].children}</Box>
        ) : (
          <Box flex={1}>
            <RadioButtonGroup
              form={form}
              direction={['column']}
              name="payment_method"
              options={options}
              onChange={handlePaymentChange}
            />
          </Box>
        )
      ) : (
        ''
      )}
    </Box>
  );
}
